import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import {
  LoadReportsAction, LoadReportsFailAction, LoadReportsSuccessAction,
  AddUserToReportAction, AddUserToReportFailAction, AddUserToReportSuccessAction,
  LoadReportsForUserAction, LoadReportsForUserFailAction, LoadReportsForUserSuccessAction,
  UpdateReportsForUserAction, UpdateReportsForUserFailAction, UpdateReportsForUserSuccessAction
} from './reports.actions';
import { ReportView } from 'src/app/features/reports/models';
import { ReportsHttpService } from 'src/app/features/reports/services';
import { Injectable } from '@angular/core';

export class ReportsStateModel {
  public isLoading: boolean;
  public reports: ReportView[];
  public usersReports: ReportView[];
}

@State<ReportsStateModel>({
  name: 'reports',
  defaults: {
    isLoading: false,
    reports: [],
    usersReports: []
  }
})
@Injectable()
export class ReportsState {

  constructor(private reportsService: ReportsHttpService) { }

  @Selector()
  static getReports(state: ReportsStateModel) {
    return state.reports;
  }

  @Selector()
  static getUserReports(state: ReportsStateModel) {
    return state.usersReports;
  }

  @Action(LoadReportsAction)
  loadReportsAction({ dispatch, patchState }: StateContext<ReportsStateModel>, action: LoadReportsAction) {
    patchState({ isLoading: true });

    return this.reportsService.getReports(action.payload.clientId).pipe(
      tap((reports) => dispatch(new LoadReportsSuccessAction({ reports }))),
      catchError((err) => dispatch(new LoadReportsFailAction()))
    );
  }

  @Action(LoadReportsSuccessAction)
  loadReportsSuccessAction(ctx: StateContext<ReportsStateModel>, action: LoadReportsSuccessAction) {
    ctx.patchState({
      isLoading: false,
      reports: action.payload.reports
    });
  }

  @Action(LoadReportsFailAction)
  loadReportsFailAction(ctx: StateContext<ReportsStateModel>, action: LoadReportsFailAction) {
    ctx.patchState({
      isLoading: false,
      reports: []
    });
  }

  @Action(AddUserToReportAction)
  addUserToReportAction({ dispatch, patchState }: StateContext<ReportsStateModel>, action: AddUserToReportAction) {
    patchState({ isLoading: true });

    return this.reportsService.updateReportsForUser(action.payload.clientId, action.payload.userRef, action.payload.reports).pipe(
      tap((success) => dispatch(new AddUserToReportSuccessAction())),
      catchError((err) => dispatch(new AddUserToReportFailAction()))
    );
  }

  @Action(AddUserToReportSuccessAction)
  addUserToReportSuccessAction(ctx: StateContext<ReportsStateModel>, action: AddUserToReportSuccessAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  @Action(AddUserToReportFailAction)
  addUserToReportFailAction(ctx: StateContext<ReportsStateModel>, action: AddUserToReportFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  @Action(UpdateReportsForUserAction)
  updateReportsForUserAction({ dispatch, patchState }: StateContext<ReportsStateModel>, action: AddUserToReportAction) {
    patchState({ isLoading: true });

    return this.reportsService.updateReportsForUser(action.payload.clientId, action.payload.userRef, action.payload.reports).pipe(
      tap((success) => dispatch(new AddUserToReportSuccessAction())),
      catchError((err) => dispatch(new AddUserToReportFailAction()))
    );
  }

  @Action(UpdateReportsForUserSuccessAction)
  updateReportsForUserSuccessAction(ctx: StateContext<ReportsStateModel>, action: AddUserToReportSuccessAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  @Action(UpdateReportsForUserFailAction)
  updateReportsForUserFailAction(ctx: StateContext<ReportsStateModel>, action: AddUserToReportFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  @Action(LoadReportsForUserAction)
  reportsForUserAction({ dispatch, patchState }: StateContext<ReportsStateModel>, action: LoadReportsForUserAction) {
    patchState({ isLoading: true });

    return this.reportsService.getReportsForUser(action.payload.clientId, action.payload.userRef).pipe(
      tap((reports) => dispatch(new LoadReportsForUserSuccessAction({ reports }))),
      catchError((err) => dispatch(new LoadReportsForUserFailAction()))
    );
  }

  @Action(LoadReportsForUserSuccessAction)
  reportsForUserSuccessAction(ctx: StateContext<ReportsStateModel>, action: LoadReportsForUserSuccessAction) {
    ctx.patchState({
      isLoading: false,
      usersReports: action.payload.reports
    });
  }

  @Action(LoadReportsForUserFailAction)
  reportsForUserFailAction(ctx: StateContext<ReportsStateModel>, action: LoadReportsForUserFailAction) {
    ctx.patchState({
      isLoading: false,
      usersReports: []
    });
  }
}
